import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { levelLabel } from "@/lib/levels";
import { Button } from "@/components/ui/button";
import { Play, Users, FileText } from "lucide-react";

export default function AgendaBrowser() {
  const [tree, setTree] = useState([]);

  useEffect(() => {
    api.get("/curriculum/tree").then(({ data }) => setTree(data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="agenda-browser">
      <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Agenda Library</span>
      <h1 className="mt-2 font-display text-4xl text-[#550001]">Browse curriculum</h1>
      <p className="mt-2 text-[#545454]">Open any class for an interactive agenda you can run live, download, or email.</p>

      <div className="mt-10 space-y-8">
        {tree.map((lvl) => (
          <div key={lvl.level} data-testid={`level-${lvl.level}`}>
            <h2 className="font-display text-2xl text-[#1a1617] border-b-2 border-[#920e12] pb-2 mb-4">{levelLabel(lvl.level)}</h2>
            {lvl.sessions.map((s) => (
              <div key={s.session_no} className="mb-5">
                <h3 className="text-sm uppercase tracking-widest font-extrabold text-[#bf6163] mb-3">Session {s.session_no}</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {s.classes.map((c) => (
                    <div key={c.id} className="bg-white rounded-2xl border border-[#dfd8da] p-5 hover:border-[#920e12] transition-colors duration-150" data-testid={`class-card-${c.id}`}>
                      <Link to={`/director/agenda/${c.id}`} data-testid={`view-class-${c.id}`} className="block group">
                        <div className="text-[10px] uppercase tracking-widest font-extrabold text-[#920e12]">Class {c.class_no}</div>
                        <h4 className="mt-1 text-lg font-bold text-[#1a1617] group-hover:text-[#920e12]">{c.title}</h4>
                        <p className="mt-1 text-sm text-[#545454]">{c.block_count} blocks · tap to view agenda</p>
                      </Link>
                      <div className="mt-4 flex gap-2">
                        <Button asChild size="sm" className="flex-1 bg-[#920e12] hover:bg-[#550001] text-white" data-testid={`run-class-${c.id}`}>
                          <Link to={`/director/run/${c.id}`}><Play size={15} className="mr-1" /> Run</Link>
                        </Button>
                        <Button asChild size="sm" variant="outline" className="border-[#920e12] text-[#920e12]" data-testid={`open-class-${c.id}`}>
                          <Link to={`/director/agenda/${c.id}`}><FileText size={15} /></Link>
                        </Button>
                        <Button asChild size="sm" variant="outline" className="border-[#d6cecf]" data-testid={`roster-class-${c.id}`}>
                          <Link to={`/director/roster/${c.id}`}><Users size={15} /></Link>
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
        {tree.length === 0 && <p className="text-[#545454]">No classes yet.</p>}
      </div>
    </div>
  );
}
